document.addEventListener('DOMContentLoaded', () => {
  console.log('Table wrapper script loaded');
  const contentSections = document.querySelectorAll('.content-section__text');
  contentSections.forEach(section => {
    const tables = section.querySelectorAll('table');
    tables.forEach(table => {
      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  });
}); 
